import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConnectionCheckService } from 'src/app/core/services/connection-check.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';

const TWO_MINUTES = 120 * 1000;

@Component({
  selector: 'th-site-down',
  templateUrl: './site-down.component.html',
  styleUrls: ['./site-down.component.scss'],
  imports: [RouterLink]
})
export class SiteDownComponent implements OnInit, OnDestroy {
  private serverConnectionCheckTimer: Subscription;

  hasServerConnection = false;
  receivedFirstResponse = false;

  constructor(
    public authService: AuthService,
    private connectionCheckService: ConnectionCheckService,
    private environmentService: EnvironmentService
  ) {}

  get supportPhone(): string {
    return this.environmentService.supportPhone;
  }

  get supportEmail(): string {
    return this.environmentService.supportEmail;
  }

  ngOnInit() {
    this.serverConnectionCheckTimer = timer(0, TWO_MINUTES).subscribe(() => {
      this.connectionCheckService.hasServerConnection().subscribe((hasServerConnection) => {
        this.receivedFirstResponse = true;

        this.hasServerConnection = hasServerConnection;
      });
    });
  }

  ngOnDestroy() {
    this.authService.siteDownRedirect = null;
    this.serverConnectionCheckTimer?.unsubscribe();
  }
}
